// this file come from @local/mobile

import defaultAxios, { AxiosRequestConfig, Method } from 'axios'

import links from './constants/links'
import { neloLogger } from './utils'

const FILE_UPLOAD_END_POINTS = Object.freeze({
  receipt: `${links.FILE_UPLOAD}/receipt`,
  mediaItem: `${links.FILE_UPLOAD}/mediaItem`,
})

/* eslint-disable indent */
const request =
  (method: Method) =>
  async (opts: AxiosRequestConfig = {}, instance = defaultAxios) => {
    const options = {
      ...opts,
      method,
    }
    if (!options.url) {
      throw new Error('opts.url is required')
    }
    return instance(options).catch(async err => {
      // log to NELO2
      const { response } = err
      neloLogger('error', { request: options, response: response || err.message })
      // and throw
      throw err
    })
  }

const restTemplate = {
  get: request('get'),
  post: request('post'),
  patch: request('patch'),
  put: request('put'),
  delete: request('delete'),
  FILE_UPLOAD_END_POINTS,
}

export default restTemplate
